// extracted by mini-css-extract-plugin
export var button = "_ft-2";
export var card = "_ft-0";
export var closeButtonContainer = "_ft-3";
export var iconContainer = "_ft-1";